import { animate, state, style, transition, trigger } from '@angular/animations';
import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { Observable, Subscription, from } from 'rxjs';
import { ChatService } from '../../../../services/chat.service';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { EquipeService } from '../../../../services/equipe.service';
import { map, startWith } from 'rxjs/operators';
import { NbWindowConfig, NbWindowRef, NbWindowService, NbWindowState } from '@nebular/theme';
import { ChatComponent } from '../chat/chat.component';
import { environment } from '../../../../environments/environment';
import { LoginService } from '../../../../services/login.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { PaginaPerguntaComponent } from '../../componetes-comum/pagina-pergunta/pagina-pergunta.component';
import { DatePipe } from '@angular/common';
import { PaginaErroComponent } from '../../componetes-comum/pagina-erro/pagina-erro.component';
import { PesquisaComponent } from '../../componetes-comum/pesquisa/pesquisa.component';
import { ClienteService } from '../../../../services/cliente.service';
import { StringMap } from '@angular/compiler/src/compiler_facade_interface';
import { ContatoEmpresaService } from '../../../../services/contato-empresa.service';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { ISO_8601 } from 'moment';
import { FilaAtendimentoManagerService } from '../../../../services/fila-atendimento-manager.service';
import { EnviaMensagemComponent } from './envia-mensagem/envia-mensagem.component';
import { ParametrosService } from '../../../../services/parametros.service';


interface Contato {
  Aniversario: string,
  Email: string,
  Id: number,
  Nome: string,
  PosicaoFuncional: string,
  TelefonePrincipal: string,
  TelefoneSecundario: string,
  idCliente: number
}

export interface ChatInterface {
  NomeUsuarioWpp: string;
  Telefone: string;
  PhoneNumberIdProd: string;
  IdChatEquipe: string;
  DataHora?: string; // ou Date, se você converter o valor para objeto Date
  Status?: string;
  UsuarioAtendente: string;
  idCliente?: number;
  nomeCliente: string;
  _id: string;
  from?: string;
}

export interface MessageFormat {
  phoneNumberId: string;
  telefone: string;
  nomeCliente?: string;
  nomeUsuario: string;
  Departamento: string;
  Assunto: string;
  idEquipeChat: string;
  idCliente?: number,
  UsuarioAtendente: string,
  EmAtendimento: boolean
}

@Component({
  selector: 'app-fila-atendimento',
  templateUrl: './fila-atendimento.component.html',
  styleUrls: ['fila-atendimento.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})
export class FilaAtendimentoComponent implements OnInit, AfterViewInit, OnDestroy {

  BoolDepartamentoGeral: boolean = false;
  EquipeChatPrincipal;
  novoClienteNaFila;
  labelAbaFila = 'Em espera';
  habilitaTrocarFila: boolean = false;
  @Input('sideBarStatus') sideBarStatus: Observable<any>
  @Input('EquipeFila') EquipeFila

  @ViewChild('refCard') refDiv: ElementRef
  refWidth: number = 0

  dataSourceFila: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  dataSourceEmEspera: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  dataSourceEmAtendimento: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  colunasFila: any = {
    Descricao: ['Contato', 'Cliente', 'Status'],
    Valor: ['NomeUsuarioWpp', 'nomeCliente', 'Status']
  }
  opcaoSelecionada
  ColunasFila: any =
    {
      Descricao: ['statusBolinha', 'Contato', 'Cliente', 'Em espera', 'Status'],
      Valor: ['statusBolinha', 'NomeUsuarioWpp', 'nomeCliente', 'Cronometro', 'Status',]
    }
  formFila: FormGroup
  FilaAtendimento: HubConnection
  ArrayFila: any
  chatsAbertos: any[]
  contextStart
  APIChat = environment.Chat
  connection: HubConnection
  intervalId
  Tooltip
  usuarioLogado
  NChatsAbertos: number
  SubChatsAbertos: Subscription
  SubEquipePrincipal: Subscription
  formularioContato: FormGroup
  ListaContatos
  filtrarContatos
  contatoSelecionado
  showListaContato: boolean = false;
  isClosing: boolean = false;
  showAssunto: boolean = false;
  isClosingAssunto: boolean = false;
  stateFilaSub
  IdEquipe = [];

  constructor(public formBuilder: FormBuilder,
    public chatService: ChatService,
    public equipeService: EquipeService,
    public windowService: NbWindowService,
    public loginService: LoginService,
    public _snackBar: MatSnackBar,
    public matDialog: MatDialog,
    public datePipe: DatePipe,
    public clienteService: ClienteService,
    private contatoService: ContatoEmpresaService,
    private FilaManagerService: FilaAtendimentoManagerService,
    private parametrosService: ParametrosService
  ) {
    this.formFila = this.formBuilder.group({
      NClientes: [1],
      Departamento: [null]
    })

    this.formularioContato = this.formBuilder.group({
      idCliente: [null],
      Cliente: [null],
      idContato: [null],
      Contato: [null],
      nomeUsuario: [null],
      TelefoneWpp: [null],
      Departamento: [null],
      Assunto: [null]
    })


    this.FilaAtendimento = this.chatService.createConnection(`${this.APIChat}/HubFilaAtendimento`, null)

  }

  ngOnInit(): void {
    this.SubChatsAbertos = this.chatService.chatsAbertos$.subscribe(response => {
      this.NChatsAbertos = response
    })
    this.usuarioLogado = this.loginService.getUsuarioDadosCompletos();
    this.Tooltip = `${this.usuarioLogado.nome}`

    this.filtrarContatos = this.formularioContato.controls.Contato.valueChanges
      .pipe(
        startWith(''),
        map(value => {
          return this._filter(value)
        })
      );


  }

  ngAfterViewInit(): void {
    this.ConectarFila()
    this.intervalId = setInterval(() => {
      this.atualizarData()
    }, 1000);

    this.refWidth = this.refDiv.nativeElement.offsetWidth;
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalId);
    this.SubChatsAbertos.unsubscribe();
    console.log(this.IdEquipe)
    this.FilaAtendimento.stop();

    this.FilaAtendimento.invoke("RemoveGroups", [this.IdEquipe[0]]);
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.ListaContatos.filter(option => option.toLowerCase().includes(filterValue));
  }

  ConectarFila(): void {
    this.opcaoSelecionada = this.EquipeFila[0]
    console.log(this.FilaAtendimento)
    this.chatService.startConnection(this.FilaAtendimento)
      .then((response) => {        
        //Esse array possui os Ids das equipes de atendimento geral whatsApp Focus e ADCCont 
        const equipesPermitidas = ['98', '119'];

        if (equipesPermitidas.includes(this.opcaoSelecionada.IdEquipeChat)) {
          this.BoolDepartamentoGeral = true
          this.SubEquipePrincipal = this.FilaManagerService.idEquipeChat$.subscribe(valor => {
            this.EquipeChatPrincipal = valor
          })
        }
        else {
          this.FilaManagerService.atualizarIdEquipeChat(this.opcaoSelecionada)
        }

        console.log(this.usuarioLogado)
        console.log(this.EquipeFila[0])

        this.IdEquipe.push(this.EquipeFila[0].IdEquipeChat)
        this.IdEquipe.push(this.EquipeFila[0].Departamento)
        this.IdEquipe.push(this.usuarioLogado.Id.toString())
        this.IdEquipe.push(this.usuarioLogado.Nome)

        console.log(this.IdEquipe)
        if (response == true) {
          this.FilaAtendimento.invoke("AddGroups", this.IdEquipe)
            .then(response => {
            })
        }
        else {
          this._snackBar.open('❌ Não foi possível se conectar a fila de atendimento.', 'Fechar', { duration: 6000 })
        }
      })

    this.FilaAtendimento.on("ReceiveMessage", (message: string) => {
      this.ArrayFila = JSON.parse(message)
      this.atualizaDataSourceFila(this.ArrayFila);
    })

    this.chatService.recebeMensagem(this.FilaAtendimento, 'newMessage')

    this.stateFilaSub = this.FilaAtendimento.onreconnected(() => {

      // this.FilaAtendimento.invoke("AddGroups", this.IdEquipe)

    })

  }

  atualizaDataSourceFila(array) {
    array.forEach((a: any) => {
      const matchingDepartamento = this.EquipeFila.find(b => b.IdEquipeChat === a.IdEquipeChat);
      if (matchingDepartamento) {
        a.Departamento = matchingDepartamento.Departamento;
      }
    });

    // ✅ Nova chamada: atualiza os contadores de mensagens
    this.chatService.atualizarContadoresMensagens(array);

    this.chatService.emitirNumeroClientes(array)
    this.dataSourceFila = new MatTableDataSource(array)
    this.dataSourceEmAtendimento = this.filaAtendimentoEmAtendimento(array)
    this.habilitaTrocarFila = this.verificaEmAtendimento(this.usuarioLogado.Nome)
    this.dataSourceEmEspera = this.filaAtendimentoEspera(array)
    this.emitirNotificacao()
  }

  emitirNotificacao() {

    if (Notification.permission !== 'granted') {
      Notification.requestPermission()
    }
    else {
      if (this.dataSourceFila.data.length > this.novoClienteNaFila) {
        this.novoClienteNaFila = this.dataSourceFila.data.length
        const notification = new Notification('Novo(s) Cliente(s) na fila de atendimento',
          { body: `${this.dataSourceEmEspera.data[this.dataSourceFila.data.length - 1].NomeUsuarioWpp}` }
        )
      }
      else {
        this.novoClienteNaFila = this.dataSourceFila.data.length
      }
    }
  }

  //Pergunta se o usuário deseja iniciar um atendimento.
  async AbrirPaginaPergunta(element: ChatInterface) {

     if (element.Status != 'Em atendimento') {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = "Deseja iniciar o atendimento?"
      this.matDialog.open(PaginaPerguntaComponent, dialogConfig)
        .afterClosed()
        .subscribe(response => {
          if (response) {
            this.iniciarConexaoChat(element)
          }
        })
    }
    else {
      this.iniciarConexaoChat(element)
    }

  }


  iniciarConexaoChat(chatInterface: ChatInterface) {
    console.log(chatInterface)
    if (this.NChatsAbertos < 3) {
      if (chatInterface.UsuarioAtendente == this.usuarioLogado.Nome || chatInterface.UsuarioAtendente == null) {
        //ID do chat é igual a PhoneNumberId + Telefone.
        let params = {
          "idUserChat": `${parseInt(chatInterface.Telefone) + parseInt(chatInterface.PhoneNumberIdProd)}`,
        }
        this.connection = this.chatService.createConnection(`${this.APIChat}/HubChat`, params)
        this.chatService.startConnection(this.connection)
          .then(response => {
            if (chatInterface.Status != 'Em atendimento') {

              console.log('Status Em espera');
              console.log(this.BoolDepartamentoGeral);

              if (this.BoolDepartamentoGeral == true) {
                
                console.log(chatInterface.IdChatEquipe);
                console.log('Nova Equipe');
                console.log(this.EquipeChatPrincipal.IdEquipeChat);

                this.FilaManagerService.trocarFilaGeral(this.FilaAtendimento, chatInterface.Telefone, chatInterface.IdChatEquipe, this.EquipeChatPrincipal.IdEquipeChat.toString())
                  .then(response => {
                    this.FilaAtendimento.invoke('SetStatusEmAtendimento', this.usuarioLogado.Nome, chatInterface.Telefone, this.EquipeChatPrincipal.IdEquipeChat.toString())
                      .then(response => {
                        if (response == 200) {
                          this.chatService.emitirChatsAbertos(this.NChatsAbertos + 1)
                          // let mensagemInicioPadrao = `Olá ${chatInterface.NomeUsuarioWpp}.\n\nMe chamo ${this.usuarioLogado.Nome}, analista do(a) ${this.EquipeFila[0].Departamento}.\n\nEm que posso ajudar?`
                          // this.connection.send('NewMessageFromChat', this.usuarioLogado.Nome, mensagemInicioPadrao, chatInterface.Telefone, chatInterface.PhoneNumberIdProd, null
                          const windowRef: NbWindowRef = this.windowService.open(ChatComponent, {
                            title: chatInterface.NomeUsuarioWpp.length > 14 ? `${new String(chatInterface.NomeUsuarioWpp).substring(0, 13)}...` : chatInterface.NomeUsuarioWpp,
                            hasBackdrop: false,
                            initialState: NbWindowState.MAXIMIZED,
                            context: {
                              start: chatInterface,
                              equipe: [this.EquipeChatPrincipal],
                              connection: this.connection,
                              connectionFila: this.FilaAtendimento,
                            },
                            windowClass: 'chat-window',
                          })

                          windowRef.stateChange.subscribe(response => {
                          })
                          windowRef.onClose.subscribe(response => {
                            this.connection.off('NewMessageFromWhatsapp')
                            this.chatService.emitirChatsAbertos(this.NChatsAbertos - 1)
                          })
                          this.recebeMensagem(this.connection)
                        }
                        if (response == 409) {
                          this.abrirPaginaErro('Este Cliente ja está em atendimento!', 'interno')
                          this.chatService.stopConnection(this.connection, `${parseInt(chatInterface.Telefone) + parseInt(chatInterface.PhoneNumberIdProd)}`)
                        }
                      })
                  })

              }
              else {
                this.FilaAtendimento.invoke('SetStatusEmAtendimento', this.usuarioLogado.Nome, chatInterface.Telefone, chatInterface.IdChatEquipe)
                  .then(response => {
                    if (response == 200) {
                      this.chatService.emitirChatsAbertos(this.NChatsAbertos + 1)
                      // let mensagemInicioPadrao = `Olá ${chatInterface.NomeUsuarioWpp}.\n\nMe chamo ${this.usuarioLogado.Nome}, analista do(a) ${this.EquipeFila[0].Departamento}.\n\nEm que posso ajudar?`
                      // this.connection.send('NewMessageFromChat', this.usuarioLogado.Nome, mensagemInicioPadrao, chatInterface.Telefone, chatInterface.PhoneNumberIdProd, null
                      const windowRef: NbWindowRef = this.windowService.open(ChatComponent, {
                        title: chatInterface.NomeUsuarioWpp.length > 14 ? `${new String(chatInterface.NomeUsuarioWpp).substring(0, 13)}...` : chatInterface.NomeUsuarioWpp,
                        hasBackdrop: false,
                        initialState: NbWindowState.MAXIMIZED,
                        context: {
                          start: chatInterface,
                          equipe: this.EquipeFila,
                          connection: this.connection,
                          connectionFila: this.FilaAtendimento,
                        },
                        windowClass: 'chat-window',
                      })

                      windowRef.stateChange.subscribe(response => {
                      })
                      windowRef.onClose.subscribe(response => {
                        this.connection.off('NewMessageFromWhatsapp')
                        this.chatService.emitirChatsAbertos(this.NChatsAbertos - 1)
                      })
                      this.recebeMensagem(this.connection)
                    }
                    if (response == 409) {
                      this.abrirPaginaErro('Este Cliente ja está em atendimento!', 'interno')
                      this.chatService.stopConnection(this.connection, `${parseInt(chatInterface.Telefone) + parseInt(chatInterface.PhoneNumberIdProd)}`)
                    }
                  })
              }
            }
            else {
              this.chatService.emitirChatsAbertos(this.NChatsAbertos + 1)
              this.recebeMensagem(this.connection)
              const windowRef: NbWindowRef = this.windowService.open(ChatComponent, {
                title: chatInterface.NomeUsuarioWpp.length > 14 ? `${new String(chatInterface.NomeUsuarioWpp).substring(0, 13)}...` : chatInterface.NomeUsuarioWpp,
                hasBackdrop: false,
                initialState: NbWindowState.MAXIMIZED,
                context: {
                  start: chatInterface,
                  equipe: this.EquipeFila,
                  connection: this.connection,
                  connectionFila: this.FilaAtendimento
                },
                windowClass: 'chat-window',
              })

              windowRef.stateChange.subscribe(response => {
              })
              windowRef.onClose.subscribe(response => {
                this.connection.off('NewMessageFromWhatsapp')
                this.chatService.emitirChatsAbertos(this.NChatsAbertos - 1)
              })

            }
          })
      }
      else {
        this.mensagemEvento(`Este Cliente ja está em atendimento com ${chatInterface.UsuarioAtendente}`, "Fechar")
      }
    }
    else {
      this._snackBar.open('Apenas 3 atendimentos são permitidos de forma simultânea. 🚨', 'Fechar', { duration: 5000 })
    }
  }

  abrirPaginaErro(mensagem, tipo) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.data = {
      mensagem: mensagem,
      tipo: tipo
    }
    this.matDialog.open(PaginaErroComponent, dialogConfig);
  }

  public mensagemEvento(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 8000,
    });
  }

  recebeMensagem(connection: HubConnection) {

    connection.on('NewMessageFromWhatsapp', (userName: string, message: string, tipoMensagem: string, date: string, nomeArquivo: string) => {
      this.chatService.emitirMessage(
        {
          chatId: connection.baseUrl,
          message: {
            user: {
              name: userName,
              avatar: 'https://cdn-icons-png.flaticon.com/512/6596/6596121.png'
            },
            text: message,
            reply: false,
            Date: date,
            type: tipoMensagem,
            files: null,
            nomeArquivo: nomeArquivo,
          }
        }
      )
    })

  }

  formataTooltip(analista: String) {
    if (analista) {
      return `Sendo atendido por ${analista}`
    }
    else {
      return null
    }
  }

  atualizarData() {
    if (this.dataSourceFila.data) {
      this.dataSourceFila.data.forEach(item => {
        item.Cronometro = this.calcularDiferencaTempo(item.DataHora);
      });
    }
  }

  calcularDiferencaTempo(dataAnterior: string): string {
    let dataAtual = new Date().getTime();
    let dataRecebida = new Date(dataAnterior).getTime();

    let diferenca = Math.abs(dataAtual - dataRecebida);

    const segundos = Math.floor(diferenca / 1000);
    const minutos = Math.floor(segundos / 60);
    const horas = Math.floor(minutos / 60);

    const segundosRestantes = segundos % 60;
    const minutosRestantes = minutos % 60;

    const horasFormatadas = horas.toString().padStart(2, '0');
    const minutosFormatados = minutosRestantes.toString().padStart(2, '0');
    const segundosFormatados = segundosRestantes.toString().padStart(2, '0');

    return `${horasFormatadas}:${minutosFormatados}:${segundosFormatados}`;
  }

  public BuscarCliente() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.data = {
      componente: "Cliente",
      condicaoQuery: `Cliente.status <> 'Inativo'`
    };

    this.matDialog
      .open(PesquisaComponent, dialogConfig)
      .afterClosed()
      .subscribe((cliente) => {
        if (cliente) {
          this.formularioContato.patchValue({
            Contato: null,
            nomeUsuario: null,
            Telefone: null,
            Departamento: null
          })
          this.formularioContato.patchValue({
            idCliente: cliente.Id,
            Cliente: cliente.Nome,
          });
          this.contatoService.getContatoChat(cliente.Id)
            .toPromise()
            .then((response: any) => {
              this.filtrarContatos = response
              this.ListaContatos = response
            })
        }
      });
  }

  selecionaContato(contato: MatAutocompleteSelectedEvent) {

    this.contatoSelecionado = contato.option.value

    this.formularioContato.patchValue({
      Contato: `${this.contatoSelecionado.Contato}` + ' - ' + `${this.contatoSelecionado.Telefone}`,
      nomeUsuario: this.usuarioLogado.Nome,
      Telefone: this.contatoSelecionado.TelefoneWpp,
      Departamento: this.EquipeFila[0].Departamento
    })

  }

  padNumber(number: number): string {
    return number.toString().padStart(2, '0');
  }

  limparCampos() {
    this.formularioContato.reset()
    this.filtrarContatos = []
    this.ListaContatos = []
  }

  abrirListaContato() {

    const dialogConfig = new MatDialogConfig();

    dialogConfig.maxWidth = '25vw'
    dialogConfig.height = '70vh'
    dialogConfig.panelClass = 'customDialogEnvio'

    this.matDialog.open(EnviaMensagemComponent, dialogConfig)
    .afterClosed()
    .subscribe(response => {
      console.log(response)
      this.AbrirPaginaPergunta(response)
    })
  }

  iniciarConversa() {
    this.isClosing = true;
    setTimeout(() => {
      this.showListaContato = false;
      this.isClosing = false;
      this.showAssunto = true
    }, 300); // Tempo de transição
    // this.limparCampos();
  }

  fecharIniciarConversa() {
    this.isClosing = true
    this.showAssunto = false;
    setTimeout(() => {
      this.isClosing = false;
      this.showListaContato = true;
    })
  }

  enviaPrimeiraMensagem() {
    let messageformat = {
      phoneNumberId: this.EquipeFila[0].PhoneNumberID,
      telefone: this.contatoSelecionado.TelefoneWpp,
      nomeCliente: this.contatoSelecionado.Contato,
      nomeUsuario: this.formularioContato.value.nomeUsuario,
      Departamento: this.EquipeFila[0].Departamento,
      Assunto: this.formularioContato.value.Assunto,
      idEquipeChat: this.EquipeFila[0].IdEquipeChat
    }
    this.chatService.enviaPrimeiraMensagem(messageformat)
      .toPromise()
      .then(response => {
        this._snackBar.open('Mensagem enviada, aguardando retorno do cliente. ✅', 'Fechar', { duration: 5000 })
        this.fecharIniciarConversa();
        setTimeout(() => {
          this.showListaContato = false;
          this.isClosing = false;
        }, 300);
        this.formularioContato.patchValue({
          Assunto: '',
        })
      })
  }

  alterarDepartamento(equipe) {
    console.log(this.IdEquipe)
    this.FilaAtendimento.invoke("RemoveGroups", this.IdEquipe).then(response => {

      this.IdEquipe = []

      this.FilaAtendimento.stop()
        .then(() => {
          this.FilaAtendimento.off("ReceiveMessage")
          this.dataSourceFila = new MatTableDataSource();

          this.chatService.startConnection(this.FilaAtendimento)
            .then((response) => {

              this.IdEquipe.push(equipe.IdEquipeChat.toString())
              this.IdEquipe.push(equipe.Departamento)
              this.IdEquipe.push(this.usuarioLogado.Id.toString())
              this.IdEquipe.push(this.usuarioLogado.Nome)

              console.log(this.IdEquipe)

              if (response == true) {
                this.FilaManagerService.atualizarIdEquipeChat(equipe)
                this.FilaAtendimento.invoke("AddGroups", this.IdEquipe)
                  .then(response => {
                  })
              }
              else {
                this._snackBar.open('❌ Não foi possível se conectar a fila de atendimento.', 'Fechar', { duration: 6000 })
              }
            })

          this.FilaAtendimento.on("ReceiveMessage", (message: string) => {
            this.ArrayFila = JSON.parse(message)
            this.atualizaDataSourceFila(this.ArrayFila);
          })

          this.chatService.recebeMensagem(this.FilaAtendimento, 'newMessage')

          this.stateFilaSub = this.FilaAtendimento.onreconnected(() => {

            this.FilaAtendimento.invoke("AddGroups", this.IdEquipe)

          })
        })
    })


  }

  verificaEmAtendimento(user) {

    if (this.dataSourceEmAtendimento.data.filter(element => { return element.UsuarioAtendente == user }).length > 0) {
      return true;
    }
    else {
      return false;
    }
  }

  filaAtendimentoEspera(array) {
    return new MatTableDataSource<any>(array.filter(response => response.Status === 'Em espera' || response.Status == 'Transferência em espera'));
  }

  filaAtendimentoEmAtendimento(array) {
    return new MatTableDataSource<any>(array.filter(response => response.Status === 'Em atendimento'));
  }
}

